import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import Box from '@mui/material/Box';

import { Breadcrumbs } from '../../components/Breadcrumbs';
import {
  PATH_USERS_DEFAULT,
  PATH_USERS_NEW_EXTERNAL,
  PATH_USERS_NEW_INTERNAL,
} from '../../app/constants/paths.constant';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';
import { UserCreationForm } from '../../forms/User';

interface Props {
  readonly isInternal: boolean;
}

// The form fills the rest of the page: the people list scrolls inside itself.
const FORM_CONTAINER_SX = { display: 'flex', flexGrow: 1, minHeight: 0 };

export const NewUserPage = ({ isInternal }: Readonly<Props>) => {
  const { setPage } = useNavigationContext();

  useEffect(() => {
    setPage(Page.Users);
  }, [setPage]);

  const title = isInternal
    ? "Création d'un Utilisateur Interne"
    : "Création d'un Utilisateur Externe";

  return (
    <>
      <Helmet>
        <title>{buildDocumentTitle(title)}</title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_USERS_DEFAULT,
            label: 'utilisateurs',
            key: 'users',
          },
          {
            to: isInternal ? PATH_USERS_NEW_INTERNAL : PATH_USERS_NEW_EXTERNAL,
            label: isInternal ? 'nouvel interne' : 'nouvel externe',
            key: 'newUser',
          },
        ]}
      />
      <PageTitle title={title} />
      <Box sx={FORM_CONTAINER_SX}>
        <UserCreationForm isInternal={isInternal} key={String(isInternal)} />
      </Box>
    </>
  );
};
